import { Command } from '@/app/tracking/api';

// REVIEW: is it needed?

export interface CompleteInteractionCommandPayload {
  interaction: InteractionDetails;
  meta: InteractionMeta;
}

export const CompleteInteractionCommandName = 'complete-interaction' as const;
export type CompleteInteractionCommand =
      Command<typeof CompleteInteractionCommandName, CompleteInteractionCommandPayload>;

interface InteractionDetails {
  id: string;
  status: InteractionStatus;
  response: string;
  result: InteractionResult;
  timestamp: Date;
  durationSeconds: number;
}

interface InteractionMeta {
  type: string;
  title: string;
}

type InteractionResult = 'passed' | 'failed' | 'neutral';

type InteractionStatus = 'not-attempted' | 'completed';

